import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import css from './AppWrapper.module.scss';

import { ToastContainer, toast } from 'react-toastify';
import Button from './components/atoms/Button';
import {
  addNotifDevice,
  clearState,
  getFirebaseToken,
  logout,
  setFirebaseToken,
} from './slices/auth';
import { setPaymentLink } from './slices/info';

export default function AppWrapper({ children }) {
  const location = useLocation();

  const { user, token, status, isNewSession, isLocked, firebaseToken } = useSelector(
    (state) => state.auth,
  );
  const { bankingCompleted, paymentLink } = useSelector((state) => state.info);
  const [isFromStripe, setIsFromStripe] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //
  useEffect(() => {
    // If user is going to auth type page, don't redirect to home
    if (status.getRefreshedToken.isSuccess && token) {
      dispatch(clearState(status.getRefreshedToken));
      if (
        !['/signup', '/forgot-password', '/verify'].includes(location.pathname) &&
        !location.pathname.includes('/confirmation') &&
        !location.pathname.includes('/forgot-password') &&
        !location.pathname.includes('/signup') &&
        !location.pathname.includes('/orders')
      )
        navigate('/home');
    }

    if (
      !['/login', '/signup', '/forgot-password', '/verify'].includes(location.pathname) &&
      !location.pathname.includes('/confirmation') &&
      !location.pathname.includes('/forgot-password') &&
      !location.pathname.includes('/signup') &&
      status.getRefreshedToken.isError &&
      status.getRefreshedToken.message == 'Null token'
    ) {
      dispatch(clearState(status.getRefreshedToken));
      navigate('/login');
    }
  }, [status, token]);

  useEffect(() => {
    if (token && firebaseToken && firebaseToken != 'sent') {
      dispatch(addNotifDevice());
    }
  }, [token, firebaseToken]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const isMobile = () => {
        let check = false;
        (function (a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              a,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4),
            )
          )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      };
      if (!isMobile()) {
        dispatch(getFirebaseToken());
      }
    }
  }, []);

  window.addEventListener(
    'livecartFirebaseToken',
    (event) => {
      const data = event.detail;
      dispatch(setFirebaseToken(data));

      // store.dispatch(addNotifDevice(data))
    },
    false,
  );

  // By Norris 8/21/2022, feel free to change.
  const BankingPopup = ({ closeToast, toastProps }) => (
    <div>
      Please link your bank account in order start selling products and get paid!
      <div className={css.buttons}>
        <Button
          color="green"
          action={() => window.open(paymentLink, '_self')}
          label={'Go to Stripe'}
        ></Button>
        <Button color="red" variant="secondary" label={'Dismiss'}></Button>
      </div>
    </div>
  );

  useEffect(
    () =>
      !bankingCompleted && paymentLink && token && !isFromStripe
        ? toast(BankingPopup, { autoClose: false })
        : null,
    [bankingCompleted],
  );
  // Enable anchor linking and scrolling in CRA
  useEffect(() => {
    const hash = location.hash;
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500); // this timeout is required because we animations on page change
  }, [location.hash]); // Fires when component mounts and every time hash changes

  useEffect(() => {
    if (
      location.pathname === '/signup' ||
      location.pathname === '/login' ||
      location.pathname === '/signup/finish'
    ) {
      document.body.classList.add('auth');
    }
    // Passwordless login succeeds and user is on login page, other wise don't redirect them

    // if (location.pathname === '/login') {
    // 	if (status.getRefreshedToken.isSuccess) {
    // 		navigate('/home')
    // 	}
    // }
    // Passwordless login fails and user is not currently logging in/logged in
    if (
      !(
        location.pathname === '/signup' ||
        location.pathname === '/login' ||
        location.pathname === '/signup/finish'
      )
    ) {
      // if (
      // 	(status.getRefreshedToken.isError && !status.login.isLoading && !token) ||
      // 	(!(
      // 		status.getRefreshedToken.isError &&
      // 		status.getRefreshedToken.isLoading &&
      // 		status.getRefreshedToken.isSuccess
      // 	) &&
      // 		!(status.login.isError && status.login.isLoading && status.login.isSuccess) &&
      // 		!token)
      // ) {
      // 	navigate('/login')
      // }
    }

    if (location.pathname == '/stripe-success') {
      setIsFromStripe(true);
      navigate('/home');
      toast.success(
        'Bank account linked successfully. Use the banking tap to view the Stripe Dashboard.',
      );

      dispatch(setPaymentLink());
    }
    if (location.pathname == '/stripe-fail') {
      setIsFromStripe(true);
      navigate('/home');
      toast.error(
        "We're having some issues with our servers right now... please try again in 24 hours",
      );
    }
    if (location.pathname != '/pin' && isLocked) {
      dispatch(logout());
      navigate('/login');

      toast.warning('Unauthorized access attempt detected, please login again.');
    }
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener(
      'livecartFirebaseToken',
      (event) => {
        const data = event.detail;
        dispatch(setFirebaseToken(data));
      },
      false,
    );
  }, []);
  // toast.info('test')
  return (
    <>
      <ToastContainer />
      {children}
    </>
  );
}
